/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {assignUnknownCustomerToVoiceCase} from '../api'

export const useMutationAssignUnknownCustomerToVoiceCase = createReactQueryMutationHook('assignUnknownCustomerToVoiceCase', assignUnknownCustomerToVoiceCase)
